import * as Headless from '@headlessui/react';
import type React from 'react';
import { forwardRef } from 'react';
import { NavLink, type NavLinkProps } from 'react-router-dom';

export const Link = forwardRef(function Link(
  props: { href: string | NavLinkProps['to'] } & Omit<NavLinkProps, 'to'>,
  ref: React.ForwardedRef<HTMLAnchorElement>,
) {
  return (
    <Headless.DataInteractive>
      <NavLink to={props.href} {...props} ref={ref} />
    </Headless.DataInteractive>
  );
});
